import { render, staticRenderFns } from "./AppsInfo.vue?vue&type=template&id=2144dc6e"
import script from "./AppsInfo.vue?vue&type=script&lang=js"
export * from "./AppsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports